module.exports = __webpack_public_path__ + "img/dianjiyun7.fb11081f.png";